import { ErrorBoundary } from "react-error-boundary";
import { ErrorBoundaryFallback } from "components/ErrorBoundaryFallback";
import { Footer } from "./components/Footer";
import { Header } from "./components/Header";
import { RouterProvider } from "react-router-dom";
import router from "routes";
import { logger } from "@caju-beneficios/monitoring";

function App() {
  const handleError = (error: Error, errorInfo: { componentStack: string }) => {
    logger.error({
      message: `ErrorBoundary - React component error: ${error.message}`,
      error,
      context: {
        application: "quero-caju",
        componentStack: errorInfo.componentStack,
      },
    });
  };

  return (
    <ErrorBoundary fallback={<ErrorBoundaryFallback />} onError={handleError}>
      <Header />
      <RouterProvider router={router} />
      <Footer />
    </ErrorBoundary>
  );
}

export default App;
